// src/Pages/Home/TrendFashion/sections/DealOfWeekFashionSection.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Image, Row } from "react-bootstrap";
import type { StoreSection } from "../../../../redux/services/store/storePagesApi";

type Props = {
  section: StoreSection;
};

const DealOfWeekFashionSection: React.FC<Props> = ({ section }) => {
  const header = (section.settings_json?.header || {}) as any;
  const cta = (section.settings_json?.cta || {}) as any;
  const styles = (section.settings_json?.styles || {}) as any;

  const items = section.items || [];
  const main = items.find((i) => i.slot === "main")?.content_json || {};

  if (!main.image_url && !header.title && !header.description && !header.badge) {
    return null;
  }

  return (
    <>
      <section
        className={
          styles.section_class ||
          "position-relative bg-danger-subtle bg-cta overflow-hidden"
        }
      >
        <Container
          fluid
          className={styles.container_class || "container-fluid ps-3 ps-lg-4 pe-0"}
        >
          <Row className="align-items-center g-0">
            <Col lg={6}>
              <div className={styles.content_class || "deal-week-content py-5 ps-lg-4"}>
                {header.badge ? (
                  <p
                    className={
                      styles.badge_class ||
                      "text-uppercase badge bg-danger-subtle text-danger fs-13 mb-3"
                    }
                    dangerouslySetInnerHTML={{ __html: header.badge }}
                  />
                ) : null}

                <h1
                  className={
                    styles.title_class ||
                    "lh-base fw-semibold mb-3 text-capitalize deal-week-title"
                  }
                  dangerouslySetInnerHTML={{
                    __html: header.title || "Deal of the week",
                  }}
                />

                {header.description ? (
                  <p
                    className={styles.description_class || "fs-16 mt-2 mb-0 deal-week-desc"}
                    dangerouslySetInnerHTML={{ __html: header.description }}
                  />
                ) : null}

                <div
                  className={
                    styles.button_wrap_class ||
                    "mt-4 pt-2 d-flex gap-2 flex-wrap deal-week-btns"
                  }
                >
                  {cta.primary_label ? (
                    <Link
                      to={cta.primary_link || "#"}
                      className={
                        cta.primary_class ||
                        `btn btn-${cta.primary_variant || "primary"} w-md btn-hover`
                      }
                    >
                      {cta.primary_label}
                    </Link>
                  ) : null}

                  {cta.secondary_label ? (
                    <Link
                      to={cta.secondary_link || "#"}
                      className={
                        cta.secondary_class ||
                        `btn btn-${cta.secondary_variant || "danger"} w-md btn-hover`
                      }
                    >
                      {cta.secondary_label}
                    </Link>
                  ) : null}
                </div>
              </div>
            </Col>

            <Col lg={6} className="pe-0">
              <div className={styles.image_wrap_class || "deal-week-image-wrap"}>
                {main.image_url ? (
                  <Image
                    src={main.image_url}
                    alt={main.alt_text || header.title || "Deal of the week"}
                    className={`${styles.image_class || ""} deal-week-image`}
                  />
                ) : null}
              </div>
            </Col>
          </Row>
        </Container>

        <style>{`
          .deal-week-content {
            position: relative;
            z-index: 2;
            max-width: 560px;
            margin-left: auto;
            padding-right: 1rem;
          }

          .deal-week-title {
            font-size: clamp(2rem, 3vw, 3rem);
          }

          .deal-week-desc {
            line-height: 1.7;
          }

          .deal-week-image-wrap {
            position: relative;
            min-height: 700px;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            overflow: visible;
            width: 100%;
          }

          .deal-week-image {
            display: block;
            max-width: none;
            height: auto;
            margin-right: -340px;
            margin-bottom: -26px;
            margin-top: 0;
          }

          @media (max-width: 1399.98px) {
            .deal-week-image-wrap {
              min-height: 660px;
            }

            .deal-week-image {
              margin-right: -290px;
              margin-bottom: -20px;
            }
          }

          @media (max-width: 1199.98px) {
            .deal-week-image-wrap {
              min-height: 590px;
            }

            .deal-week-image {
              margin-right: -220px;
              margin-bottom: -16px;
            }
          }

          @media (max-width: 991.98px) {
            .deal-week-content {
              max-width: 100%;
              margin-left: 0;
              padding-bottom: 1rem !important;
              padding-right: 0;
              text-align: center;
            }

            .deal-week-btns {
              justify-content: center;
            }

            .deal-week-image-wrap {
              min-height: auto;
              justify-content: center;
              align-items: center;
              margin-top: 1rem;
              overflow: hidden;
            }

            .deal-week-image {
              width: 100%;
              max-width: 520px;
              margin-right: 0;
              margin-bottom: 0;
            }
          }

          @media (max-width: 575.98px) {
            .deal-week-content {
              padding-top: 2.5rem !important;
            }

            .deal-week-title {
              font-size: 1.75rem;
            }

            .deal-week-desc {
              font-size: 0.95rem;
            }

            .deal-week-image-wrap {
              margin-top: 0.5rem;
            }

            .deal-week-image {
              max-width: 100%;
            }
          }
        `}</style>
      </section>
    </>
  );
};

export default DealOfWeekFashionSection;